export default __webpack_public_path__ + "static/media/phonee_motorola-motoe-black-portrait.4fba52e9.png";